var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentxLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4541 62.7683H7.77757C3.48214 62.7683 0 66.2505 0 70.5459V93.2224C0 97.5178 3.48214 101 7.77757 101H30.4541C34.7495 101 38.2316 97.5178 38.2316 93.2224V70.5459C38.2316 66.2505 34.7495 62.7683 30.4541 62.7683Z",
    fill: "#15052A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2224 0H70.5459C66.2505 0 62.7683 3.48214 62.7683 7.77757V30.4541C62.7683 34.7495 66.2505 38.2316 70.5459 38.2316H93.2224C97.5178 38.2316 101 34.7495 101 30.4541V7.77757C101 3.48214 97.5178 0 93.2224 0Z",
    fill: "#15052A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3181 68.7542L32.2458 2.68192C30.9962 1.05565 29.0332 0 26.8192 0H6.84746C3.06424 0 0 3.06424 0 6.84746V26.8192C0 28.8563 0.895876 30.6766 2.30531 31.932L2.28249 31.9548L69.6158 99.2881L69.6386 99.2653C70.8484 100.338 72.4347 101 74.1808 101H94.1525C97.9358 101 101 97.9358 101 94.1525V74.1808C101 71.9668 99.9444 70.0038 98.3181 68.7542Z",
    fill: "#15052A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentxLogoDark);
export default __webpack_public_path__ + "static/media/identxLogoDark.813ba574984680d7933005da9159d9e3.svg";
export { ForwardRef as ReactComponent };